import React, {useState} from 'react';
import PageButton from '../elements/PageButton/PageButton';
import {INITIAL_MUSIC_VOLUME, LOCAL_STORAGE_KEY_MUSIC_VOLUME} from '../../constants/sound';
import './MusicMuteToggleButton.css';

// pageId обязателен: кнопка живет на четырех экранах, и раньше все ее клики
// уходили в статистику как клики на странице входа — по ним нельзя было
// понять, какой экран человек на самом деле видел
function MusicMuteToggleButton({className, pageId}) {
  const [volume, setVolume] = useState(() => {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY_MUSIC_VOLUME);
    const parsed = parseFloat(stored);
    return isNaN(parsed) ? INITIAL_MUSIC_VOLUME : Math.max(0, Math.min(1, parsed));
  });

  const isMuted = volume === 0;

  const handleClick = () => {
    const nextVolume = isMuted ? INITIAL_MUSIC_VOLUME : 0;
    setVolume(nextVolume);
    localStorage.setItem(LOCAL_STORAGE_KEY_MUSIC_VOLUME, nextVolume.toString());
    window.dispatchEvent(new CustomEvent('musicvolumechange', {detail: {volume: nextVolume}}));
  };

  return (
    <PageButton
      className={`music-mute-toggle-button ${className ? className : ''}`}
      onClick={handleClick}
      pageId={pageId}
      buttonId="music-mute-toggle"
    >
      <img
        className="music-mute-toggle-button_icon"
        src={isMuted ? '/img/icons/volume_off.png' : '/img/icons/volume.png'}
        alt={isMuted ? 'Включить музыку' : 'Выключить музыку'}
        title={isMuted ? 'Включить музыку' : 'Выключить музыку'}
      />
    </PageButton>
  );
}

export default MusicMuteToggleButton;
